module.exports = __webpack_public_path__ + "img/exclamation-triangle.310302bc.svg";